import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { ProfessionalLogsType } from '../../../types';


type LegendType = "top" | "right" | "bottom" | "left" | undefined;

const WellbeingVASScoreChart = () => {
  const client = useSelector((state: RootState) => state.professionals.selectedClient);
  const seriesMemo = useMemo(() => {
    if (!client || !client.professionalLogs) return [];

    const sortedLogs = client.professionalLogs.slice().sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

    const mainHealthComplaintScores = sortedLogs.map((log: ProfessionalLogsType) => log.mainHealthProblemVasScore);
    const generalWellBeingScores = sortedLogs.map((log: ProfessionalLogsType) => log.generalWellBeingVasScore);
    const energyLevelScores = sortedLogs.map((log: ProfessionalLogsType) => log.energyLevelVasScore);

    return [
      {
        name: 'Presence of Main Health Complaint',
        type: 'line',
        data: mainHealthComplaintScores,
      },
      {
        name: 'General wellbeing',
        type: 'line',
        data: generalWellBeingScores,
      },
      {
        name: 'Energy level',
        type: 'line',
        data: energyLevelScores,
      },
    ];
  }, [client]);

  const options = {
    chart: {
      id: 'line',
      toolbar: {
        show: false,
      },
    },
    legend: {
      position: 'top' as LegendType,
      offsetY: 0,
      markers: {
        fillColors: ['#42A5F5', '#FFB74D', '#81C784'],
      },
    },
    stroke: {
      width: [3.5, 3.5, 3.5],
      curve: 'straight' as any,
    },
    xaxis: {
      categories: ['28 Aug. 2024', '28 Aug. 2024 (1)'],
    },
    yaxis: {
      min: 0,
      max: 10,
      tickAmount: 10,
    },
    colors: ['#42A5F5', '#FFB74D', '#81C784'],
    markers: {
      size: 5,
    },
  };

  return (
    <div>
      <Chart options={options} series={seriesMemo} type="line" height={350} />
    </div>
  );
};

export default WellbeingVASScoreChart;
